// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3AyyW","left":"StickyBox_left__13D64","right":"StickyBox_right__1qPc3"};